import * as fromDatatype from '../datatype-library/index';

export interface bl_b2b_process_tracking_einvoice_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    einvoice_email_ocr_hdr_guid: fromDatatype.GuidDataFieldInterface;
    peppol_generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    match_source: fromDatatype.VarcharDatatypeInterface;
    doc_reference: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    delivery_order_no: fromDatatype.VarcharDatatypeInterface;
    purchase_order_no: fromDatatype.VarcharDatatypeInterface;
    unique_id_no: fromDatatype.VarcharDatatypeInterface;
    supplier_id_no: fromDatatype.VarcharDatatypeInterface;
    supplier_tin: fromDatatype.VarcharDatatypeInterface;
    supplier_name: fromDatatype.VarcharDatatypeInterface;
    supplier_registration_number: fromDatatype.VarcharDatatypeInterface;
    supplier_sst_id: fromDatatype.VarcharDatatypeInterface;
    supplier_msic_code: fromDatatype.VarcharDatatypeInterface;
    supplier_business_activity_desc: fromDatatype.VarcharDatatypeInterface;
    supplier_phone: fromDatatype.VarcharDatatypeInterface;
    supplier_email: fromDatatype.VarcharDatatypeInterface;
    supplier_address: fromDatatype.VarcharDatatypeInterface;
    buyer_id_no: fromDatatype.VarcharDatatypeInterface;
    buyer_tin: fromDatatype.VarcharDatatypeInterface;
    buyer_name: fromDatatype.VarcharDatatypeInterface;
    buyer_sst_id: fromDatatype.VarcharDatatypeInterface;
    buyer_address: fromDatatype.VarcharDatatypeInterface;
    buyer_phone: fromDatatype.VarcharDatatypeInterface;
    buyer_email: fromDatatype.VarcharDatatypeInterface;
    buyer_reference: fromDatatype.VarcharDatatypeInterface;
    amount_txn: fromDatatype.NumericDatatypeInterface;
    amount_net: fromDatatype.NumericDatatypeInterface;
    amount_payable: fromDatatype.NumericDatatypeInterface;
    amount_tax: fromDatatype.NumericDatatypeInterface;
    tax_type: fromDatatype.NumericDatatypeInterface;
    tax_rate: fromDatatype.NumericDatatypeInterface;
    einvoice_type: fromDatatype.VarcharDatatypeInterface;
    einvoice_version: fromDatatype.VarcharDatatypeInterface;
    einvoice_code: fromDatatype.VarcharDatatypeInterface;
    ccy_code: fromDatatype.VarcharDatatypeInterface;
    payment_mode: fromDatatype.VarcharDatatypeInterface;
    billing_frequency: fromDatatype.VarcharDatatypeInterface;
    billing_period: fromDatatype.VarcharDatatypeInterface;
    digital_signature: fromDatatype.VarcharDatatypeInterface;
    validation_datetime: fromDatatype.TimestampTzDatatypeInterface;
    value_matching_status: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    document_matching_status: fromDatatype.VarcharDatatypeInterface;
    supplier_remarks: fromDatatype.VarcharDatatypeInterface;
    payment_status: fromDatatype.VarcharDatatypeInterface;
    action_deadline: fromDatatype.TimestampTzDatatypeInterface;
    amount_difference: fromDatatype.NumericDatatypeInterface;
}

export class bl_b2b_process_tracking_einvoice_hdr_RowClass implements bl_b2b_process_tracking_einvoice_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    einvoice_email_ocr_hdr_guid: fromDatatype.GuidDataFieldInterface;
    peppol_generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    match_source: fromDatatype.VarcharDatatypeInterface;
    doc_reference: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    delivery_order_no: fromDatatype.VarcharDatatypeInterface;
    purchase_order_no: fromDatatype.VarcharDatatypeInterface;
    unique_id_no: fromDatatype.VarcharDatatypeInterface;
    supplier_id_no: fromDatatype.VarcharDatatypeInterface;
    supplier_tin: fromDatatype.VarcharDatatypeInterface;
    supplier_name: fromDatatype.VarcharDatatypeInterface;
    supplier_registration_number: fromDatatype.VarcharDatatypeInterface;
    supplier_sst_id: fromDatatype.VarcharDatatypeInterface;
    supplier_msic_code: fromDatatype.VarcharDatatypeInterface;
    supplier_business_activity_desc: fromDatatype.VarcharDatatypeInterface;
    supplier_phone: fromDatatype.VarcharDatatypeInterface;
    supplier_email: fromDatatype.VarcharDatatypeInterface;
    supplier_address: fromDatatype.VarcharDatatypeInterface;
    buyer_id_no: fromDatatype.VarcharDatatypeInterface;
    buyer_tin: fromDatatype.VarcharDatatypeInterface;
    buyer_name: fromDatatype.VarcharDatatypeInterface;
    buyer_sst_id: fromDatatype.VarcharDatatypeInterface;
    buyer_address: fromDatatype.VarcharDatatypeInterface;
    buyer_phone: fromDatatype.VarcharDatatypeInterface;
    buyer_email: fromDatatype.VarcharDatatypeInterface;
    buyer_reference: fromDatatype.VarcharDatatypeInterface;
    amount_txn: fromDatatype.NumericDatatypeInterface;
    amount_net: fromDatatype.NumericDatatypeInterface;
    amount_payable: fromDatatype.NumericDatatypeInterface;
    amount_tax: fromDatatype.NumericDatatypeInterface;
    tax_type: fromDatatype.NumericDatatypeInterface;
    tax_rate: fromDatatype.NumericDatatypeInterface;
    einvoice_type: fromDatatype.VarcharDatatypeInterface;
    einvoice_version: fromDatatype.VarcharDatatypeInterface;
    einvoice_code: fromDatatype.VarcharDatatypeInterface;
    ccy_code: fromDatatype.VarcharDatatypeInterface;
    payment_mode: fromDatatype.VarcharDatatypeInterface;
    billing_frequency: fromDatatype.VarcharDatatypeInterface;
    billing_period: fromDatatype.VarcharDatatypeInterface;
    digital_signature: fromDatatype.VarcharDatatypeInterface;
    validation_datetime: fromDatatype.TimestampTzDatatypeInterface;
    value_matching_status: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    document_matching_status: fromDatatype.VarcharDatatypeInterface;
    supplier_remarks: fromDatatype.VarcharDatatypeInterface;
    payment_status: fromDatatype.VarcharDatatypeInterface;
    action_deadline: fromDatatype.TimestampTzDatatypeInterface;
    amount_difference: fromDatatype.NumericDatatypeInterface;
}
